import React, { ChangeEvent, useState } from 'react';
import { toast, Toaster } from 'react-hot-toast';
import { useMutation } from 'react-query';

import { ValidationHelper } from '@project/helpers';
import { operationsService } from '@project/services';
import { FileUpload, ProgressBar, TailwindButton } from '@project/components';

const BulkFinesUploadScreen: React.FC = () => {
  const [file, setFile] = useState<File | null>(null);
  const [ImportNotifyEmail, setImportNotifyEmail] = useState<string | null>(null);
  const [uploadProgress, setUploadProgress] = useState<number | null>(null);

  const onChangeDropZoneFile = (inputFile: File) => {
    setFile(inputFile);
    setUploadProgress(null);
  };

  const onChangeEmail = (event: ChangeEvent<HTMLInputElement>) => {
    if (ValidationHelper.emailRegexValidation.test(event.target.value)) {
      setImportNotifyEmail(event.target.value);
    } else {
      setImportNotifyEmail(null);
    }
  };

  const useFileUploadMutation = useMutation(
    'uploadCapeTownCsv',
    () => {
      setUploadProgress(0);
      return operationsService.uploadBulkImportFile(file, ImportNotifyEmail, setUploadProgress);
    },
    {
      onSuccess: () => {
        toast.success('Successfully uploaded file');
        setFile(null);
        setUploadProgress(null);
      },
      onError: () => {
        toast.error('An error occurred while uploading file');
        setUploadProgress(null);
      },
    },
  );

  return (
    <>
      <Toaster />
      <div className="flex items-center justify-center flex-col">
        <div className="my-5 text-lg">Upload General Fines</div>
        <div className="flex justify-center items-center w-full">
          <FileUpload onChange={onChangeDropZoneFile} file={file} />
        </div>
        {uploadProgress !== null && (
          <div className="mt-4 w-1/2">
            <ProgressBar
              progress={uploadProgress}
              label={uploadProgress < 100 ? 'Uploading file' : 'Processing file on the server'}
            />
          </div>
        )}
        <div className="m-3 flex gap-2 items-center">
          <span className="text-gray-400">Email: </span>
          <input
            id="email"
            onChange={onChangeEmail}
            type="text"
            className="border-solid border-2"
          />
          <TailwindButton
            className="bg-tertiary hover:bg-tertiary-dark focus:bg-tertiary-dark self-center"
            isDisabled={!file || !ImportNotifyEmail}
            isLoading={useFileUploadMutation.isLoading}
            onClick={() => useFileUploadMutation.mutateAsync()}
            type="submit"
          >
            Upload {file?.name ?? ''}
          </TailwindButton>
        </div>
      </div>
    </>
  );
};

export default BulkFinesUploadScreen;
